import React from "react";
import "./LeadsCard.css";
// import { Link } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import ContactDetails from "../Contacts/ContactDetail";
import { Drawer } from "@material-ui/core";
import { getContactImageUrl } from "../../config";
import { getContactImageUrl2 } from "../../config";

import { useState } from "react";

function MediaCard3(props) {

  const [openPoup, SetOpenPopup] = useState(false);
  const [userid, SetUserid] = useState(0);

  const formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  const onNameClick = (side, open, row) => event => {

    SetOpenPopup(true);
    SetUserid(row.id)

  }


  const rows = props.DashboardData[13];


  return rows.map(row => (
    <div className="item">
      <div className="profile-img-box">
        <img
          src={row.profileimage}
          onError={({ currentTarget }) => {
            let imageSourceUrl = getContactImageUrl;
            if (row.id > 917500) {
              imageSourceUrl = getContactImageUrl2;
            }
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = imageSourceUrl.url + row.image;
          }}
        />
      </div>

      <div className="detail-box">
        <h3 className="name" component="th"
          scope="row" style={{ cursor: "pointer" }}

          onClick={onNameClick("openDetails", true, row)}>
          {row.name}{" "}
          <span>{row.contactStatus !== null ? row.contactStatus : ""}</span>



        </h3>

        <div className="address-text">
          {row.designation !== null && row.designation !== "" ? row.designation + "," : ""} {" "}
          {row.location !== null ? row.location : ""}
        </div>



        <div className="date-info">
          {" "}
          Connected on{" "}
          {row.connectedOn !== null ? formatDate(row.connectedOn) : " "}{" "}
          <span>
            {" "}
            Last response on{" "}
            {row.lastResponse !== null ? formatDate(row.lastResponse) : ""}
          </span>
        </div>
        <div className="stage-text">
          {row.currentstatus !== null ? row.currentstatus : ""} {row.currentstatusdate !== null ? formatDate(row.currentstatusdate) : ""}
        </div>
        <div className="stage-text-detail">
          <span>
            {row.company !== null ? row.company : ""}, {row.linkedinprofile !== null ? row.linkedinprofile : ""}, {row.campaign !== null ? row.campaign : ""}
          </span>
        </div>
      </div>

      {row.id == userid && (




        <Drawer
          anchor="right"
          open={openPoup}

        >
          <ContactDetails


            Close={() => SetOpenPopup(false)}
            details={row}
            Campaignid={row.campaignid}

            id={row.id}

            heading={"Contact Details"}
          />
        </Drawer>
      )}

    </div>

  ));

  function onClickCard(currentHeader) {
    props.onClickCard(currentHeader);
  }


}
const mapDispatchToProps = dispatch => {

  return {
    onHandleCampaign: data =>
      dispatch({
        type: "Campaign_Detail",
        payload: data
      })
  };
};
export default connect(null, mapDispatchToProps)(MediaCard3);

